module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_5_A.966c2348.mp3";